import {publish} from '@/script/event.mjs'

export const pushSave = () => () => {
    return async function () {
        await this.execute(
            () => this.runAction(
                async () => {
                    const results = await this.actions.pushProduct([this.root])
                    const rejected = results.find(e => 'rejected' === e.status)

                    if (rejected) {
                        throw rejected.reason
                    }

                    await this.actions.saveMap()
                    publish(this, 'save')
                },

                {action: '更新制品'}
            )
        )
    }
}
